import * as common from '../common/Common';
import { appService } from '../common/AppService';

export class SignUpViewModel {
    public username='';
    public nickname='';
    public password='';
    public password2='';
    public error = '';

    public showSuccessMessage=false;

    public submit() {
        this.error='';
        if (!this.username || !this.nickname || !this.password || !this.password2) {
            this.error = 'Please fill all the information.';
        } else if (this.password !== this.password2) {
            this.error = 'Two passwords don\'t match.';
        } else {
            common.callHttp('POST', 'user/signup', {
                Username: this.username,
                Nickname: this.nickname,
                Password: this.password
            }).then(() => {
                this.showSuccessMessage=true;
            }, error => {
                this.error = error.ExceptionMessage;                
            });
        }
    }
}